import { seriesOgHashes } from '@/data/series-og';

/**
 * Path of a series' generated OG card (#617). The content hash is appended as
 * `?v=` because /og/* is served immutable for a year: a changed card must be a
 * new URL. Hashes come from src/data/series-og.js, written by
 * scripts/generate-series-og-images.mjs.
 */
export const getSeriesOgImage = (slug) => {
  const hash = seriesOgHashes[slug];
  return `/og/series/${slug}.png${hash ? `?v=${hash}` : ''}`;
};
